export default class RfidCellRenderer{
  constructor(invalidCellContainerClassName = 'CellContainer--invalid',
              invalidRowClassName           = 'Row--invalid',
              validCellClassName            = 'Cell--valid',
              invalidCellClassName          = 'Cell--invalid',
              tooltipText                   = 'Clique duas vezes para editar'){
    this.invalidCellContainerClassName = invalidCellContainerClassName;
    this.invalidRowClassName           = invalidRowClassName;
    this.validCellClassName            = validCellClassName;
    this.invalidCellClassName          = invalidCellClassName;
    this.tooltipText                   = tooltipText;

    this.onValid = () => {
      return (cellValue) => `<span class='Cell ${validCellClassName}'>${cellValue}</span>`
    }

    this.onInvalid = () => {
      return (cellValue) => `<span class='Cell ${invalidCellClassName}'>${cellValue}</span>`
    }
  }
}
